import { EVENT_TYPES } from '@constants/eventTypes.ts';

export const ALL = 'All';
export const ASSIGNED = 'Assigned';
export const UNREAD = 'Unread';
export const READ = 'Read';
export const PAGE_SIZE_OPTIONS = [5, 10, 20];
export const NON_OPT_OUT_NOTIFICATION_EVENT_TYPES = [
    EVENT_TYPES.ASSIGNED,
    EVENT_TYPES.REMINDER,
    EVENT_TYPES.FINAL_REMINDER,
];

export const ASSESSOR_OPEN_NOTIFICATION_TYPES = [
    EVENT_TYPES.TASK_RECEIVED_FOR_EVALUATION,
    EVENT_TYPES.TASK_RECEIVED_FOR_EXEMPTION,
];

export const NOTIFICATIONS_VIEW_SCROLLABLE_SELECTOR = 'main.ant-layout-content';
